import { container } from "tsyringe";
import ApiService from "../../services/ApiService";
import { RevenueDashboardMapper } from "@/data/persistences/mappers/RevenueDashboardMapper";
import { RevenueDashboardEndpoint } from "../../endpoints/RevenueDashboardEndpoint";
import { RevenueDashboardPresenter } from "@/app/ui/presenters/RevenueDashboardPresenter";
import { RevenueDashboardApiRepository } from "../../repositories/api/RevenueDashboardApiRepository";
import { PosRevenuePresenter } from "@/app/ui/presenters/PosRevenuePresenter";
import { PosRevenueApiRepository } from "../../repositories/api/PosRevenueApiRepository";
import { PosRevenueMapper } from "@/data/persistences/mappers/PosRevenueMapper";
import { PosRevenueEndpoints } from "../../endpoints/hydra/PosRevenueEndpoints";

export class RevenueDashboardComponent {
  public static init() {
    container.register<RevenueDashboardApiRepository>(
      RevenueDashboardApiRepository,
      {
        useFactory: (d) => {
          return new RevenueDashboardApiRepository(
            d.resolve(ApiService),
            d.resolve(RevenueDashboardMapper),
            d.resolve(RevenueDashboardEndpoint)
          );
        }
      }
    );
    container.register<RevenueDashboardMapper>(RevenueDashboardMapper, {
      useClass: RevenueDashboardMapper
    });
    container.register(RevenueDashboardPresenter, {
      useFactory: (d) => {
        return new RevenueDashboardPresenter(
          d.resolve(RevenueDashboardApiRepository)
        );
      }
    });

    
    container.register<PosRevenueApiRepository>(PosRevenueApiRepository, {
      useFactory: (d) => {
        return new PosRevenueApiRepository(
          d.resolve(ApiService),
          d.resolve(PosRevenueMapper),
          d.resolve(PosRevenueEndpoints)
        );
      }
    });
    container.register<PosRevenueMapper>(PosRevenueMapper, {
      useClass: PosRevenueMapper
    });
    container.register<PosRevenueEndpoints>(PosRevenueEndpoints, {
      useClass: PosRevenueEndpoints
    });
    container.register<PosRevenuePresenter>(PosRevenuePresenter, {
      useFactory: (d) => {
        return new PosRevenuePresenter(d.resolve(PosRevenueApiRepository));
      }
    });
  }
}
